module.exports = __webpack_public_path__ + "static/media/unboxing_spring_2.98b14b68.jpg";